import "styles/reset.css";
import "styles/foundation.css";
import "styles/utilities.css";
import "styles/components.css";
import "styles/main.css";
import "styles/pages.css";
import "styles/spa-global.css";

import ReactDOM from "react-dom/client";
import store from 'core/store';
import React from "react";
import App from "./App";

import { Provider } from "react-redux";
import { BrowserCheck } from "BrowserCheck";
import { capturePromoCode } from "core/promoLink";

// 매장 홍보 링크(?a=가입코드) — 첫 화면이 /main·/m 으로 넘어가며 주소가 바뀌기 전에 쿠키로 기억해 둔다(가입 창 추천인 자동 기입)
capturePromoCode();

// 그랜드라인(build:jp): REACT_APP_FAVICON 설정 시에만 파비콘 교체(다른 빌드 무영향)
// 기존 아이콘 링크(정적 favicon_default 등)를 전부 제거하고 버전 쿼리 붙은 새 링크를 주입한다.
//   - 옛 default/캐시본을 브라우저(특히 Edge)가 잡지 않도록 링크 자체를 갈아끼움
//   - REACT_APP_FAVICON 값에 ?v= 를 포함해 Cloudflare 엣지 캐시를 우회
if (process.env.REACT_APP_FAVICON) {
  document.querySelectorAll("link[rel~='icon']").forEach((el) => el.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.setAttribute("sizes", "any");
  link.href = "/" + process.env.REACT_APP_FAVICON;
  document.head.appendChild(link);
}

// 그랜드라인: 탭 제목 = 브랜드명 (REACT_APP_BRAND 설정 시). 이후 백엔드 site_name 은 !document.title 가드로 덮지 않음.
if (process.env.REACT_APP_BRAND) {
  document.title = process.env.REACT_APP_BRAND;
}

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
});

window.addEventListener('appinstalled', () => {
  window.deferredPrompt = null;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <App />
    {/* </React.StrictMode> */}
  </Provider>
);

BrowserCheck();
